// extracted by mini-css-extract-plugin
export default {"tableHeader":"CustomTable_tableHeader__k52rG","tableCell":"CustomTable_tableCell__MU5VA","customTable":"CustomTable_customTable__FEdS0"};